<template>
  <div class="card accompagnement-card h-100 shadow-sm">
    <div class="card-img-top-wrapper">
      <img
        src="@/assets/img/photo/8654599.jpg"
        class="card-img-top"
        :alt="$t('miseAuLitResume.image.alt')"
      />
    </div>

    <div class="card-body d-flex flex-column">
      <h5 class="fw-bold" style="font-size: 1.3rem">
        {{ $t("miseAuLitResume.title") }}
      </h5>

      <p class="text-muted" style="font-size: 1rem; line-height: 1.4">
        {{ $t("miseAuLitResume.text.p1") }}
      </p>

      <a href="/mise-au-lit-tardive" class="btn btn-custom mt-2 w-100 mt-auto">
        {{ $t("miseAuLitResume.button.more") }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "MiseAuLitResume",
};
</script>

<style></style>
